import { render } from "./patient-invoices-modal.vue?vue&type=template&id=33a5a2fc"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__